import type { SetupOutputs } from './setup';

export interface SetupReadiness {
  ready: boolean;
  missing: string[];
  activeAudiences: string[];
  activeVoices: string[];
  activePersonaCount: number;
  activeThemeCount: number;
  hasBrandKit: boolean;
}

export function getSetupReadiness(data: SetupOutputs | undefined): SetupReadiness {
  const activeAudiences = data?.audiences.filter((a) => a.isSelected).map((a) => a.name) ?? [];
  const activeVoices = data?.voices.filter((v) => v.isSelected).map((v) => v.name) ?? [];
  const activePersonaCount = data?.personas.filter((p) => p.isActive).length ?? 0;
  const activeThemeCount = data?.themes.filter((t) => t.isActive).length ?? 0;
  const hasBrandKit = !!data?.brandKit;

  const missing: string[] = [];
  if (activeAudiences.length === 0) missing.push('active audience');
  if (activeVoices.length === 0) missing.push('active voice');
  if (activePersonaCount === 0) missing.push('active persona');
  if (activeThemeCount === 0) missing.push('active theme');
  if (!hasBrandKit) missing.push('brand kit');

  return {
    ready: missing.length === 0,
    missing,
    activeAudiences,
    activeVoices,
    activePersonaCount,
    activeThemeCount,
    hasBrandKit,
  };
}
